import React from 'react';
import { t } from 'i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';

interface WidgetsViewEmptyStateProps {
  isViewOnly: boolean;
  isDefault: boolean;
  onCustomize: () => void;
}

export default function WidgetsViewEmptyState({
  isViewOnly,
  isDefault,
  onCustomize,
}: WidgetsViewEmptyStateProps) {
  const actions = isViewOnly
    ? undefined
    : [
        <Button
          key="customize"
          buttonText={t('customize-company-view')}
          buttonType={ButtonTypes.primaryFilled}
          onClick={onCustomize}
        />,
      ];

  const title = isDefault
    ? t('home-page-empty-state-title')
    : t('home-page-custom-empty-state-title');

  const text = isDefault
    ? t('home-page-empty-state-description')
    : t('home-page-custom-empty-state-description');

  return (
    <EmptyState
      icon={IconName.Home}
      title={title}
      text={text}
      actions={actions}
    />
  );
}
